import { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { formValidator } from "../FormValidator";

import $ from "jquery";

let modalComponents = [];
const todayFormatted = new Date().toISOString().split("T")[0];
export const LeadForm = () => {
  const formRef = useRef();
  const message = useRef();

  const [countryCodes, setCountryCodes] = useState([]);
  const [error, setError] = useState();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    code: "US",
    country: "United States ",
    codeNumber: "+1",
    phoneNumber: "",
    personalSocialMedia: "",
    projectTitle: "",
    projectBudget: "",
    website: "",
    socialMedia: "",
    isLogo: "",
    isWebsite: "",
    isSocialMedia: "",
    leadType: "",
    leadStatus: "",
    leadPriority: "Medium",
    nextAction: "",
    nextFollowUpDate: todayFormatted,
    internalNotes: "",
    services: [],
    createDateTime: "",

    isRequired: [
      "name",
      "projectTitle",
      "projectBudget",
      "leadStatus",
      "nextAction",
    ],
  });
  const budgets = [
    "Under 1,500",
    "1,500 - 3,000 USD",
    "3,000 - 5,000 USD",
    "5,000 - 8,000 USD",
    "8,000 - 15,000 USD",
    "15,000 - 25,000 USD",
    "25,000 - 40,000 USD",
    "+40,000 USD",
  ];

  const leadStatusArr = [
    "New Lead",
    "Contacted",
    "Quailified",
    "Meeting Scheduled",
    "Demo Pending",
    "Proposal Sent",
    "Negotiation",
    "Won",
    "Lost",
  ];

  const nextActionArr = [
    "Schedule a Call",
    "Call Back",
    "Send Email",
    "Send Proposal",
    "Schedule Demo",
    "Follow Up",
    "Awaiting Client Response",
    "Close Lead",
  ];

  const dodArr = ["Doesn't have", "Out dated", "Decent"];

  function handleInputChange(e) {
    let { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState, // Copy all other key-value pairs
      [name]: value, // Update the specific field that changed
    }));
  }

  function hideSelectContent(e) {
    for (let i = 0; i < modalComponents.length; i++) {
      modalComponents[i].classList.remove("open");
      modalComponents[i].parentElement
        .querySelector(".custom-select-content")
        .classList.remove("open");
    }
    modalComponents.length = 0;

    if (e.target.required == true) {
      setTimeout(() => {
        if (e.target.value == "") e.target.parentElement.classList.add("error");
        else e.target.parentElement.classList.remove("error");
      }, 200);
    }
  }

  function handleCodeClick(e) {
    const inputComp = e.target.parentElement.getElementsByTagName("input");

    inputComp.value = e.target.getAttribute("data-code");

    setFormData((prevState) => ({
      ...prevState,
      ["code"]: e.target.getAttribute("data-code"),
      ["codeNumber"]: e.target.getAttribute("data-number"),
      ["country"]: e.target.getAttribute("data-country"),
    }));

    let flagBgX = -1;
    let z = 0;

    const dvs = e.target.parentElement.parentElement.querySelectorAll(
      ".custom-select-content div",
    );
    dvs.forEach((child) => {
      if (
        e.target.getAttribute("data-code") == child.getAttribute("data-code") &&
        flagBgX == -1
      )
        flagBgX = -45 * z;
      z++;
    });
    e.target.classList.add("active");
    $(".flags").css("background-position-x", flagBgX);
  }

  function uncheckAll(component) {
    const parent = component
      .closest(".form-group")
      .querySelectorAll(".checkbox");
    for (let i of parent)
      if (i.classList.contains("checked")) i.classList.toggle("checked");
  }
  function toogleSelect(e) {
    const mainComp = e.target.parentElement.querySelector(".select");
    mainComp?.classList.toggle("open");

    const content = mainComp.parentElement.querySelector(
      ".custom-select-content",
    );
    content.classList.toggle("open");

    if (content.classList.contains("open")) {
      const inputComp = mainComp.getElementsByTagName("input")[0];
      inputComp.focus();

      modalComponents.push(e.target);
    }
  }

  function changeFollowUpDate(e) {

    setFormData(prev => ({
      ...prev,
      nextFollowUpDate: e.target.value
    }));

  }

  function handleCheckboxEvent(e) {

    const component = e.currentTarget;

    const parent = component.parentElement;
    const isMultiple = parent?.getAttribute("data-multiple") === "true";

    const stateName = isMultiple
      ? parent.id
      : component.getAttribute("name");

    const newValue = isMultiple
      ? component.textContent.trim()
      : component.getAttribute("value");

    if (!stateName) return;

    if (isMultiple) {
      setFormData((prev) => {
        const currentValues = Array.isArray(prev[stateName])
          ? prev[stateName]
          : [];

        const updatedValues = currentValues.includes(newValue)
          ? currentValues.filter((item) => item !== newValue)
          : [...currentValues, newValue];

        return {
          ...prev,
          [stateName]: updatedValues,
        };
      });
    } else {
      uncheckAll(component);

      setFormData((prev) => ({
        ...prev,
        [stateName]: newValue,
      }));
    }

    component.classList.toggle("checked");


    // const component = e.target;
    // let isChecked =
    //   component.classList.toString().indexOf("checked") > -1 ? true : false;

    // let newValue = component.innerHTML;

    // if (component.parentElement.getAttribute("data-multiple") == "true") {
    //   let stateName = component.parentElement.id;
    //   let index = eval("formData." + stateName).indexOf(newValue);
    //   let updatedServices =
    //     index > -1
    //       ? eval("formData." + stateName).splice(index, 1)
    //       : eval("formData." + stateName).push(newValue);
    //   setFormData((prevState) => ({
    //     ...prevState, // Copy all other key-value pairs
    //     [stateName]: eval("formData." + stateName), // Update the specific field that changed
    //   }));
    // } else {
    //   uncheckAll(e.target);

    //   console.log(component.getAttribute("name"));
    //   setFormData((prevState) => ({
    //     ...prevState, // Copy all other key-value pairs
    //     [component.getAttribute("name")]: component.getAttribute("value"), // Update the specific field that changed
    //   }));
    // }
    // component.classList.toggle("checked");
  }

  function checkValidation(e) {
    let checkSpecific;

    if (e != undefined)
      checkSpecific =
        "check" +
        e.target.name.charAt(0).toUpperCase() +
        e.target.name.slice(1);

    const [errors, isValid] = formValidator(formData, checkSpecific);
    $("#formSubmitBtn").attr("disabled", !isValid);

    if (e != undefined) {
      if (errors.length > 0) e.target.parentElement.classList.add("error");
      else e.target.parentElement.classList.remove("error");
    }
  }

  function handleSelectClick(e, name, value) {
    const inputComp =
      e.target.parentElement.parentElement.getElementsByTagName("input")[0];

    inputComp.value = value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  const handleInputDate = (e) => {
    try {
      e.target.showPicker();
    } catch (error) {
      console.log("showPicker not supported or blocked:", error);
    }
  };

  async function handleFormSubmission(e) {
    e.preventDefault();

    e.target.querySelector("button").innerHTML =
      "<div>Sending Request...<i className='progress' /></div>";
    e.target.querySelector("button").disabled = true;

    try {
      let customFormData = formData;
      customFormData.serviceString = formData.services
        .toString()
        .split(",")
        .join(", ");
      let words = formData.name.toString().split(" ");
      const name = words
        .map((word) => {
          if (word.length > 0)
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

          return word;
        })
        .toString()
        .split(",")
        .join(" ");
      customFormData.name = name;

      const now = new Date();
      let currentTime = now.toLocaleTimeString([], { hour12: false });
      let currentDate =
        now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
      customFormData.createDateTime = currentDate + "T" + currentTime;

      console.log(customFormData);

      const response = await fetch(
        "https://hook.us2.make.com/p2x4noapb3v6ggjmthvvyc4n6513nrpc",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // "x-make-apikey": "R0bust!k@p!key",
            "x-make-apikey": "R0bust!k@p!key",
          },
          body: JSON.stringify(customFormData),
        },
      );

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();
      console.log("Response: ", data);
      document.querySelector("#anchorThankYou").click();
      e.target.querySelector("button").disabled = false;

      console.log(customFormData);

      e.target.querySelector("button").innerHTML =
        "<div>Send Request<i className='progress' /></div>";
      e.target.querySelector("button").disabled = true;

      message.current.classList.add("show");



    } catch (error) {
      console.log("Fetch Error: ", error.message);
    }
  }

  useEffect(() => {
    const fetchData = async (url) => {
      try {
        const response = await fetch(url);
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);

        setCountryCodes(await response.json());
      } catch (err) {
        console.log("Catch:" + err);
      }
    };

    fetchData("/assets/js/country-codes.json");

    const fetchIp = async () => {
      try {
        const response = await fetch("https://api.ipify.org/?format=json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        const userIP = data.ip;

        try {
          const response = await fetch("https://ipinfo.io/" + userIP + "/json");
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();

          $("#selectCode")
            .parent()
            .find(".custom-select-content div")
            .each(function () {
              if ($(this).data("code").split(" ")[0] == data.country) {
                $(this).trigger("click");
              }
            });
        } catch (err) {
          setError(err.message);
        }
      } catch (err) {
        setError(err.message);
      }
    };
    fetchIp();
  }, []);

  useEffect(() => {
    message.current.classList.remove("show");
    // const fc = formRef.current.querySelectorAll("input");

    // let check = true;

    // for (const input of fc) if (document.activeElement === input) check = false;

    // if (check) checkValidation();

    checkValidation();
  }, [formData]);

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://robustik.com/contact" />
      </Helmet>
      <section className="hero ">
        <div className="container">
          <div className="hh2 text-center">
            <span className="text-primary font-semibold"></span>
            Customer Data Form
          </div>

          <form
            ref={formRef}
            noValidate
            onSubmit={handleFormSubmission}
            autoComplete="off"
            spellCheck="false"
            method="post"
            className="mt-20 xl:w-1/2 mx-auto"
          >
            <div className="hh5 mb-10 ">1 / Client Information</div>

            <div className="flex flex-wrap -mx-5">
              <div className="w-full xl:w-1/2 form-group px-5">
                <label>Customer Name *</label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  placeholder="e.g. Nic Miller"
                  onBlur={checkValidation}
                  onChange={handleInputChange}
                  value={formData.name}
                  required
                  autoComplete="newpassword"
                  spellCheck="false"
                  aria-labelledby="Name"
                />
                <div className="input-border"></div>
                <div className="input-error">* Name is required</div>
              </div>

              <div className="w-full  xl:w-1/2 form-group px-5">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="e.g. nicmiller@company.com"
                  onBlur={checkValidation}
                  onChange={handleInputChange}
                  value={formData.email}
                  autoComplete="newpassword"
                  aria-labelledby="Email"
                />
                <div className="input-border"></div>
              </div>
            </div>

            <div className="flex flex-wrap -mx-5">
              <div className="w-full xl:w-1/2 ">
                <div className="w-full flex  form-group">
                  <div className="px-5">
                    <label id="country-code-label">Country</label>
                    <div
                      className="flex select"
                      onClick={toogleSelect}
                      id="selectCode"
                    >
                      <div className="flags-wrapper">
                        <div className="flags"></div>
                      </div>
                      <input
                        type="text"
                        name="code"
                        onBlur={hideSelectContent}
                        className="code"
                        value={formData.code}
                        readOnly
                        aria-labelledby="country-code-label"
                      />
                      <span></span>
                      <div className="input-border"></div>
                    </div>

                    <div className="custom-select-content" data-lenis-prevent>
                      {countryCodes.map((code, index) => (
                        <div
                          key={index}
                          data-code={code.code}
                          data-number={code.dial_code}
                          data-country={code.name}
                          onClick={handleCodeClick}
                        >
                          <span />
                          {code.name + "  (" + code.dial_code + ")"}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="flex flex-col  w-full relative">
                    <label>Phone Number</label>
                    <input
                      className="phone"
                      type="text"
                      name="phoneNumber"
                      id="phoneNumber"
                      placeholder="(+1) 659 225 9107"
                      onChange={handleInputChange}
                      value={formData.phoneNumber}
                      autoComplete="newpassword"
                      spellCheck="false"
                      aria-labelledby="Phone Number"
                    />
                    <div className="input-border"></div>
                  </div>
                </div>
              </div>
              <div className="w-full  xl:w-1/2 form-group px-5 mt-6 lg:mt-0 lg:mt-0  ">
                <label>Social Medial / Linkedin</label>
                <input
                  type="text"
                  name="personalSocialMedia"
                  id="personalSocialMedia"
                  placeholder="e.g. https://facebook.com/NicMiller"
                  onBlur={checkValidation}
                  onChange={handleInputChange}
                  value={formData.personalSocialMedia}
                  autoComplete="newpassword"
                  aria-labelledby="Email"
                />
                <div className="input-border"></div>
              </div>
            </div>

            <div className="hh5 mb-10 mt-20 ">2 / Project Details</div>

            <div className="flex flex-wrap -mx-5">
              <div className="w-full  px-5 form-group">
                <label>Project Title *</label>
                <input
                  type="text"
                  name="projectTitle"
                  id="projectTitle"
                  placeholder="e.g Brand Website"
                  onBlur={checkValidation}
                  onChange={handleInputChange}
                  value={formData.projectTitle}
                  required
                  aria-labelledby="Project Title"
                />
                <div className="input-border"></div>
                <div className="input-error">* Project Title is required</div>
              </div>
            </div>

            <div className="flex flex-wrap -mx-5">
              <div className="w-full  px-5  form-group required">
                <label>Project Budget *</label>
                <div className="flex select" onClick={toogleSelect}>
                  <input
                    type="text"
                    name="projectBudget"
                    id="projectBudget"
                    onBlur={hideSelectContent}
                    // onChange={checkValidation}
                    placeholder="Select your estimated budget"
                    value={formData.projectBudget}
                    required
                    readOnly
                  />
                  <span />
                  <div className="input-border"></div>
                  <div className="input-error">
                    * Project Budget is required
                  </div>
                </div>
                <div className="custom-select-content" data-lenis-prevent>
                  {budgets.map((budget, index) => (
                    <div
                      key={index}
                      onClick={(e) => {
                        handleSelectClick(e, "projectBudget", budget);
                      }}
                    >
                      <span />
                      {budget}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex flex-wrap  -mx-5">
              <div className="w-full xl:w-1/2 form-group px-5">
                <label>Website URL</label>
                <input
                  type="text"
                  name="website"
                  id="website"
                  placeholder="e.g. https://veracitydesign.studio"
                  onChange={handleInputChange}
                  value={formData.website}
                  autoComplete="newpassword"
                  spellCheck="false"
                  aria-labelledby="Name"
                />
                <div className="input-border"></div>
              </div>

              <div className="w-full  xl:w-1/2 mt-6 xl:mt-0 form-group px-5">
                <label>Social Media URL</label>
                <input
                  type="text"
                  name="socialMedia"
                  id="socialMedia"
                  placeholder="e.g. https://facebook.com/veracitydesignstudio"
                  onChange={handleInputChange}
                  value={formData.socialMedia}
                  autoComplete="newpassword"
                  aria-labelledby="Name"
                />
                <div className="input-border"></div>
              </div>
            </div>

            <div className="flex flex-wrap mt-6 -mx-5">
              <div className="w-full  xl:w-full form-group  px-5">
                <label>Branding / Logo</label>

                <div
                  className="flex flex-wrap gap-x-10 mt-2 gap-y-4 "
                  data-multiple="false"
                >
                  {dodArr.map((service, index) => (
                    <div
                      key={index}
                      className="checkbox"
                      name="isLogo"
                      value={service}
                      onClick={handleCheckboxEvent}
                    >
                      {service}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex flex-wrap mt-6 -mx-5">
              <div className="w-full  xl:w-full form-group  px-5">
                <label>Wesbsite</label>

                <div
                  className="flex flex-wrap gap-x-10 mt-2 gap-y-4  "
                  data-multiple="false"
                >
                  {dodArr.map((service, index) => (
                    <div
                      key={index}
                      className="checkbox"
                      name="isWebsite"
                      value={service}
                      onClick={handleCheckboxEvent}
                    >
                      {service}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex flex-wrap mt-6 -mx-5">
              <div className="w-full  xl:w-full form-group  px-5">
                <label>Social Media</label>

                <div
                  className="flex flex-wrap gap-x-10 gap-y-8 mt-2 "
                  data-multiple="false"
                >
                  {dodArr.map((service, index) => (
                    <div
                      key={index}
                      className="checkbox"
                      name="isSocialMedia"
                      value={service}
                      onClick={handleCheckboxEvent}
                    >
                      {service}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="hh5 mb-10 mt-20 ">
              3 / Lead Qualification & Follow-up
            </div>

            <div className="flex flex-wrap mt-6 -mx-5">
              <div className="w-full  xl:w-full form-group  px-5">
                <label>Lead Type</label>

                <div className="flex flex-wrap gap-x-10 gap-y-4 mt-2 ">

                  <div
                    className="checkbox"
                    onClick={handleCheckboxEvent}
                    name="leadType"
                    value="Inbound"
                  >
                    Inbound
                  </div>


                  <div
                    className="flex flex-wrap gap-x-10 gap-y-4 "
                    data-multiple="false"
                  >
                    <div
                      className="checkbox"
                      onClick={handleCheckboxEvent}
                      name="leadType"
                      value="Outbound"
                    >
                      Outbound
                    </div>
                  </div>

                  <div
                    className="flex flex-wrap gap-x-10 gap-y-8 "
                    data-multiple="false"
                  >
                    <div
                      className="checkbox"
                      onClick={handleCheckboxEvent}
                      name="leadType"
                      value="Referral"
                    >
                      Referral
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className=" -mx-5 mt-6">
              <div className="w-full   px-5  form-group required">
                <label>Lead Status *</label>
                <div className="flex select " onClick={toogleSelect}>
                  <input
                    type="text"
                    name="leadStatus"
                    id="leadStatus"
                    onBlur={hideSelectContent}
                    onChange={checkValidation}
                    placeholder="Select lead status"
                    value={formData.leadStatus}
                    required
                    readOnly
                  />
                  <span />
                  <div className="input-border"></div>
                  <div className="input-error">* Lead Status is required</div>
                </div>
                <div className="custom-select-content" data-lenis-prevent>
                  {leadStatusArr.map((leadStatus, index) => (
                    <div
                      key={index}
                      onClick={(e) => {
                        handleSelectClick(e, "leadStatus", leadStatus);
                      }}
                    >
                      <span />
                      {leadStatus}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex flex-wrap -mx-5">
              <div className="w-full  xl:w-full form-group  px-5">
                <label>Lead Priority</label>

                <div className="flex gap-10">
                  <div
                    className="flex flex-wrap gap-x-10 gap-y-8 "
                    data-multiple="false"
                  >
                    <div
                      className="checkbox"
                      onClick={handleCheckboxEvent}
                      name="leadPriority"
                      value="Low"
                    >
                      Low
                    </div>
                  </div>

                  <div
                    className="flex flex-wrap gap-x-10 gap-y-8 "
                    data-multiple="false"
                  >
                    <div
                      className="checkbox"
                      onClick={handleCheckboxEvent}
                      name="leadPriority"
                      value="Medium"
                    >
                      Medium
                    </div>
                  </div>

                  <div
                    className="flex flex-wrap gap-x-10 gap-y-8 "
                    data-multiple="false"
                  >
                    <div
                      className="checkbox"
                      onClick={handleCheckboxEvent}
                      name="leadPriority"
                      value="High"
                    >
                      High
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap -mx-5 mt-6">
              <div className="w-full  xl:w-1/2  px-5  form-group required">
                <label>Next Action *</label>
                <div className="flex select" onClick={toogleSelect}>
                  <input
                    type="text"
                    name="nextAction"
                    id="nextAction"
                    onBlur={hideSelectContent}
                    onChange={checkValidation}
                    placeholder="Select Next Action"
                    value={formData.nextAction}
                    required
                  />
                  <span />
                  <div className="input-border"></div>
                  <div className="input-error">* Next Action is required</div>
                </div>
                <div className="custom-select-content" data-lenis-prevent>
                  {nextActionArr.map((nextAction, index) => (
                    <div
                      key={index}
                      onClick={(e) => {
                        handleSelectClick(e, "nextAction", nextAction);
                      }}
                    >
                      <span />
                      {nextAction}
                    </div>
                  ))}
                </div>
              </div>

              <div className="w-full  xl:w-1/2  px-5 form-group">
                <label>Next Follow-up Date</label>
                <div className="flex ">
                  <input
                    type="date"
                    id="startDate"
                    value={formData.nextFollowUpDateke}
                    onChange={(e) => changeFollowUpDate(e)}
                    onClick={handleInputDate}
                    defaultValue={todayFormatted}
                  />
                </div>
              </div>
            </div>

            <div className="flex flex-wrap -mx-5 mt-6 xl:mt-0">
              <div className="w-full  form-group px-5">
                <label>Internal Notes</label>

                <textarea
                  rows="5"
                  type="text"
                  name="internalNotes"
                  id="name"
                  placeholder="e.g. Short Description"
                  onBlur={checkValidation}
                  onChange={handleInputChange}
                  value={formData.internalNotes}
                  autoComplete="newpassword"
                  spellCheck="false"
                  aria-labelledby="Name"
                />
                <div className="input-border"></div>
              </div>
            </div>

            <div className="mt-6">
              <button disabled={true} id="formSubmitBtn">
                <div>
                  Send Request<i></i>
                </div>
              </button>
            </div>
            <div ref={message} className="lead-message show">
              Your request has been submitted successfully.
            </div>
          </form>
        </div>
      </section>
    </>
  );
};
